<div id="table-header" #tableHeaderElement [class.sticky]="isTableHeaderSticky">
  <div class="row" [ngClass]="{ disabled: isDisabled }">
    <div id="checkbox" *ngIf="isCheckboxColumnVisible">
      <mat-checkbox
        color="primary"
        [checked]="isCheckboxChecked"
        [(ngModel)]="isCheckboxChecked"
        (change)="toggleCheckboxChanged($event)"
      ></mat-checkbox>
    </div>
    <div
      *ngFor="let itemTH of tableHeader"
      class="th"
      [style.width.%]="itemTH.percentageWidth"
      (click)="orderBy(itemTH)"
      [ngClass]="{ clickeable: itemTH.isOrderByVisible }"
    >
      <span
        class="title-column"
        [class.selected]="orderByColumn == itemTH.id && itemTH.isOrderByVisible"
        >{{ itemTH.text }}</span
      >
      <div
        *ngIf="itemTH.isOrderByVisible"
        class="arrow-order-by"
        [class.selected]="orderByColumn == itemTH.id"
        [class.des]="orderByOrientation == 'DES'"
      ></div>
    </div>
  </div>
</div>
